import * as React from 'react'
import {
  FooterArea,
  Logo,
  GridContainer,
  GridItem,
  HardTitle,
  Link,
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
  YouTubeIcon
} from './PublicFooter.styles'
import {
  PUBLIC_URL,
  REACT_APP_TERMS_AND_CONDITIONS_URL,
  REACT_APP_OPENED_DATA_URL,
  REACT_APP_PUBLIC_MARKET_API_URL,
  REACT_APP_CAPACITACION_BASE_URL,
  REACT_APP_CENTROAYUDA_BASE_URL,
  REACT_APP_FIRTS_NUMBER,
  REACT_APP_SECOND_NUMBER,
  REACT_APP_CONTACT_URL,
  REACT_APP_FACEBOOK_URL,
  REACT_APP_TWITTER_URL,
  REACT_APP_LINKEDIN_URL,
  REACT_APP_YOUTUBE_URL,
  REACT_APP_INSTAGRAM_URL
} from '../../config/settings/environment'
import { Typography } from '@chilecompra/react-kit/components'

/**
 * The Public Footer container.
 */
const PublicFooterContainer = () => {
  return (
    <FooterArea position="fixed">
      <GridContainer justifyContent="space-around;">
        <GridItem xl={2} lg={2} sm={12} xs={12}>
          <Logo alt="Logo Chile compra" src={`${PUBLIC_URL}/assets/images/logo_direccion_chilecompra.svg`} />
        </GridItem>
        <GridItem xl={2} lg={2} sm={6} xs={12} sx={{ minWidth: { lg: '250px', xl: '280px' } }}>
          <HardTitle fontSize="14px" color="white" variant="body2" fontWeight="bold" tabIndex="0">
            Dirección ChileCompra
          </HardTitle>
          <Typography fontSize="12px" color="white" variant="body2" margin="8px 0 0" tabIndex="0">
            Ministerio de Hacienda Gobierno de Chile
          </Typography>
          <Typography fontSize="12px" color="white" variant="body2" margin="8px 0 0" tabIndex="0">
            Monjitas 392 - Piso 8, Santiago de Chile
          </Typography>
          <Typography color="white" variant="body2" fontWeight="bold" fontSize="12px" margin="8px 0 0">
            <Link target="_blank" rel="noreferrer" href={REACT_APP_TERMS_AND_CONDITIONS_URL}>
              Términos y condiciones
            </Link>
          </Typography>
        </GridItem>
        <GridItem xl={2} lg={2} sm={6} xs={12} sx={{ minWidth: { lg: '170px' } }}>
          <HardTitle fontSize="14px" color="white" variant="body2" fontWeight="bold" tabIndex="0">
            Sitios relacionados
          </HardTitle>
          <Typography color="white" fontSize="12px" variant="body2" margin="8px 0 0">
            <Link target="_blank" rel="noreferrer" href={REACT_APP_OPENED_DATA_URL}>
              Datos Abiertos ChileCompra
            </Link>
          </Typography>
          <Typography color="white" fontSize="12px" variant="body2" margin="8px 0 0">
            <Link target="_blank" rel="noreferrer" href={REACT_APP_PUBLIC_MARKET_API_URL}>
              API Mercado Público
            </Link>
          </Typography>
          <Typography color="white" fontSize="12px" variant="body2" margin="8px 0 0">
            <Link target="_blank" rel="noreferrer" href={REACT_APP_CAPACITACION_BASE_URL}>
              Capacitación
            </Link>
          </Typography>
        </GridItem>
        <GridItem xl={2} lg={2} sm={6} xs={12} sx={{ minWidth: { lg: '170px' }, paddingRight: { xl: '0px' } }}>
          <HardTitle fontSize="14px" color="white" variant="body2" fontWeight="bold" tabIndex="0">
            Mesa de ayuda
          </HardTitle>
          <Typography color="white" fontSize="12px" variant="body2" margin="8px 0 0">
            <Link target="_blank" rel="noreferrer" href={REACT_APP_CENTROAYUDA_BASE_URL}>
              Centro de Ayuda
            </Link>
          </Typography>
          <Typography color="white" fontSize="12px" variant="body2" margin="8px 0 0">
            <Link href={`tel:+${REACT_APP_FIRTS_NUMBER}`}> 600 0061 211 </Link>
          </Typography>
          <Typography color="white" fontSize="12px" variant="body2" margin="8px 0 0">
            <Link href={`tel:+${REACT_APP_SECOND_NUMBER}`}>+56 2 2595 0820</Link>
          </Typography>
          <Typography color="white" fontSize="12px" variant="body2" margin="8px 0 0">
            <Link target="_blank" rel="noreferrer" href={REACT_APP_CONTACT_URL}>
              Contacto
            </Link>
          </Typography>
        </GridItem>
        <GridItem xl={2} lg={2} sm={6} xs={12} sx={{ padding: { xl: '0', lg: '0' }, maxWidth: { xl: '280px' } }}>
          <HardTitle fontSize="14px" color="white" variant="body2" fontWeight="bold" margin="0 0 8px" tabIndex="0">
            Siguenos
          </HardTitle>
          <GridContainer flexWrap="nowrap" alignItems="center" height="28px">
            <Link
              target="_blank"
              rel="noreferrer"
              href={REACT_APP_FACEBOOK_URL}
              aria-label="Facebook se abre en una nueva ventana"
            >
              <FacebookIcon src={`${PUBLIC_URL}/assets/images/facebook_icon.svg`} />
            </Link>
            <Link
              target="_blank"
              rel="noreferrer"
              href={REACT_APP_TWITTER_URL}
              aria-label="Twitter se abre en una nueva ventana"
            >
              <TwitterIcon src={`${PUBLIC_URL}/assets/images/twitter_icon.svg`} />
            </Link>
            <Link
              target="_blank"
              rel="noreferrer"
              href={REACT_APP_LINKEDIN_URL}
              aria-label="LinkedIn se abre en una nueva ventana"
            >
              <LinkedInIcon src={`${PUBLIC_URL}/assets/images/linkedin_icon.svg`} />
            </Link>
            <Link
              target="_blank"
              rel="noreferrer"
              href={REACT_APP_YOUTUBE_URL}
              aria-label="Youtube se abre en una nueva ventana"
            >
              <YouTubeIcon src={`${PUBLIC_URL}/assets/images/youtube_icon.svg`} />
            </Link>
            <Link
              target="_blank"
              rel="noreferrer"
              href={REACT_APP_INSTAGRAM_URL}
              aria-label="Instagram se abre en una nueva ventana"
            >
              <InstagramIcon src={`${PUBLIC_URL}/assets/images/instagram_icon.svg`} />
            </Link>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </FooterArea>
  )
}

export default PublicFooterContainer
